import script from "./AiNotification.vue?vue&type=script&lang=ts&setup=true"
export * from "./AiNotification.vue?vue&type=script&lang=ts&setup=true"

import "./AiNotification.scss?vue&type=style&index=0&id=30b5588c&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b5588c"]])

export default __exports__